export const themeEditorUiConfigCountdown = [
  {
    sectionName: "Content Blocks - Countdown",
    sectionKey: "contentBlocks.countdown",
    description: "Styling for countdown content block type",
    groups: [
      {
        groupName: "Common",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.countdown.container.color",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Countdown default text color",
            options: {
              allowInherit: true,
              modalTitle: "Countdown Default Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "contentBlocks.countdown.container.background",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Countdown default background color",
            options: {
              allowInherit: true,
              modalTitle: "Countdown Default Background Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.countdown.container.fontSize",
            component: "FontSizeSelector",
            default: "1.75rem",
            allowCustom: true,
            description: "Countdown default font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.countdown.container.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Countdown default font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.countdown.container.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Countdown default font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Title",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.countdown.title.color",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Countdown title text color",
            options: {
              allowInherit: true,
              modalTitle: "Countdown Title Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.countdown.title.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Countdown title font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.countdown.title.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Countdown title font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.countdown.title.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Countdown title font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Time",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.countdown.time.color",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Countdown time text color",
            options: {
              allowInherit: true,
              modalTitle: "Countdown Time Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.countdown.time.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Countdown time font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.countdown.time.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Countdown time font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.countdown.time.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Countdown time font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Almost Up",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.countdown.almostUp.color",
            component: "ColorSelector",
            default: "#dc2626",
            description: "Countdown almost up text color",
            options: {
              allowInherit: true,
              modalTitle: "Countdown Almost Up Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.countdown.almostUp.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Countdown almost up font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.countdown.almostUp.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Countdown almost up font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.countdown.almostUp.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Countdown almost up font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "On Done",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.countdown.onDone.color",
            component: "ColorSelector",
            default: "#16a34a",
            description: "Countdown done text color",
            options: {
              allowInherit: true,
              modalTitle: "Countdown Done Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.countdown.onDone.fontSize",
            component: "FontSizeSelector",
            default: "2rem",
            allowCustom: true,
            description: "Countdown done font size",
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.countdown.onDone.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Countdown done font weight",
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.countdown.onDone.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Countdown done font family",
          },
        ],
      },
    ],
  },
];
